import * as React from 'react'
import Dialog from '@material-ui/core/Dialog'
import { useAtom } from 'jotai'
import styled from 'styled-components'
import { X } from '@geist-ui/react-icons'
import { crossmintBuyAtom, PurchaseType } from '../../atoms/Wallet'
import { useMediaQuery } from '@material-ui/core'
import CartItem from './SecondaryMarket/CartItem'
import { CrossmintPayButton } from '@crossmint/client-sdk-react-ui'
import {
  ClickBuyWithCreditCardPrimary,
  ClickBuyWithCreditCardSecondary,
  ClickBuyWithETHPrimary,
  ClickBuyWithETHSecondary,
} from '../../events/revenue_events'
import log from '../../events/log'

// ========================== React component ==================================

interface CrossmintWHArgs {
  price: number
  token_size: number
  type: string
  buyer: string
  seller: string
}

const CrossmintBuyDialog = (): JSX.Element => {
  //   const [, setToast] = useToasts()
  const isMobile = useMediaQuery('(max-width: 43em)')
  const [purchaseInfo, setOpen] = useAtom(crossmintBuyAtom)
  const [whArgs, setWhArgs] = React.useState<CrossmintWHArgs | undefined>(undefined)

  React.useEffect(() => {
    if (purchaseInfo) {
      setWhArgs({
        price: purchaseInfo.priceLamports,
        token_size: purchaseInfo.tokenSize,
        type: purchaseInfo.purchaseType === PurchaseType.PRIMARY ? 'primary' : 'secondary',
        buyer: purchaseInfo.buyer,
        seller: purchaseInfo.seller,
      })
    }
  }, [purchaseInfo])

  return (
    <Dialog
      onClose={() => {
        console.log('Closed')
      }}
      aria-labelledby="crossmint-dialog"
      open={purchaseInfo !== undefined}
      PaperProps={{
        style: {
          backgroundColor: '#101010',
          borderRadius: 15,
          minWidth: isMobile ? '90vw' : '500px',
          width: isMobile ? '90vw' : '50vh',
          borderWidth: 1,
          borderColor: '#262626',
          borderStyle: 'solid',
          minHeight: '400px',
          height: '30vh',
        },
      }}
      BackdropProps={{
        style: {
          backdropFilter: 'blur(20px)',
        },
      }}
    >
      <OuterDiv>
        <CloseButton color="white" size={'30px'} onClick={() => setOpen(undefined)} />
        <Title>Checkout</Title>
        {purchaseInfo && (
          <CartItem
            videoTitle={purchaseInfo.video.title}
            creatorName={purchaseInfo.creatorName}
            videoThumbnailUrl={'https://us.glassapi.xyz/' + purchaseInfo.video.thumbnail_uri}
            floorPrice={purchaseInfo.price}
            primary={purchaseInfo.purchaseType === PurchaseType.PRIMARY}
          />
        )}
        <Row>
          {purchaseInfo && (
            <CrossmintPayButton
              className="crossmint"
              clientId={
                purchaseInfo.purchaseType === PurchaseType.PRIMARY
                  ? 'd24ec4d8-d7b0-4ec0-8d7d-175d2ddb5b1d'
                  : '8b0e6e5d-2399-41a7-bba7-9dd56c6d5c77'
              }
              mintConfig={{
                mintHash: purchaseInfo?.video.address,
                sellerWallet: purchaseInfo?.seller,
                type: '',
              }}
              theme="light"
              environment={
                process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ? 'production' : 'staging'
              }
              whPassThroughArgs={JSON.stringify(whArgs)}
              showOverlay={false}
              onClick={() => {
                log(
                  purchaseInfo.purchaseType === PurchaseType.PRIMARY
                    ? new ClickBuyWithCreditCardPrimary(purchaseInfo.video.address)
                    : new ClickBuyWithCreditCardSecondary(purchaseInfo.video.address)
                )
                setOpen(undefined)
              }}
            />
          )}
          {purchaseInfo && (
            <CrossmintPayButton
              className="crossmint"
              clientId={
                purchaseInfo.purchaseType === PurchaseType.PRIMARY
                  ? 'd24ec4d8-d7b0-4ec0-8d7d-175d2ddb5b1d'
                  : '8b0e6e5d-2399-41a7-bba7-9dd56c6d5c77'
              }
              mintConfig={{
                mintHash: purchaseInfo?.video.address,
                sellerWallet: purchaseInfo?.seller,
                type: '',
              }}
              environment={
                process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ? 'production' : 'staging'
              }
              paymentMethod="ETH"
              whPassThroughArgs={JSON.stringify(whArgs)}
              showOverlay={false}
              onClick={() => {
                log(
                  purchaseInfo.purchaseType === PurchaseType.PRIMARY
                    ? new ClickBuyWithETHPrimary(purchaseInfo.video.address)
                    : new ClickBuyWithETHSecondary(purchaseInfo.video.address)
                )
                setOpen(undefined)
              }}
            />
          )}
        </Row>
      </OuterDiv>
    </Dialog>
  )
}

export default CrossmintBuyDialog

// ========================== Styled components ================================

const OuterDiv = styled.div`
  width: calc(100% - 100px);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 50px;
  margin-top: 0px;
`

const Title = styled.div`
  color: white;
  font-size: 28px;
  font-weight: 600;
  text-align: center;
  padding: 25px 0;

  @media (max-width: 43em) {
    font-size: 24px;
  }
`

const CloseButton = styled(X)`
  right: 4%;
  top: 4%;
  position: absolute;
  cursor: pointer;
`

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: calc(100% + 40px);
  gap: 25px;

  @media (max-width: 43em) {
    margin-top: 25px;
    width: calc(100%);
    flex-direction: column;
  }

  .crossmint {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    font-weight: 700;
    font-family: 'Inter', -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto, Ubuntu;

    img {
      display: none;
    }
  }
`
